import { render } from "./EmailField.vue?vue&type=template&id=2c8f2482"
import script from "./EmailField.vue?vue&type=script&lang=js"
export * from "./EmailField.vue?vue&type=script&lang=js"

import exportComponent from "/home/harlan/sites/kintell-env/api/packages/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"EmailField.vue"]])

export default __exports__